<template>
    <div class="d-flex gap-3">
        <input type="hidden" name="head_id" :value="selectedHead">
        <div class="manager-forward__head-selector px-3 py-2 rounded border border-success d-flex align-items-center">
            <label for="head_id" class="manager-forward__title form-label mb-0 me-2">
                {{
                    {
                        ru: 'Руководитель',
                        kz: 'Басшы',
                        en: 'Head',
                    }[getLang()]
                }}
            </label>
            <select
                id="head_id"
                v-model="selectedHead"
                class="border-0 bg-transparent p-0 fw-semibold select2"
                style="width: 75%"
                :disabled="!heads.length"
                required
            >
                <option value="">
                    {{
                        {
                            ru: 'Не выбрано',
                            kz: 'Басшы',
                            en: 'Not selected',
                        }[getLang()]
                    }}
                </option>
                <option v-for="head in heads" :key="head.id" :value="head.id">
                    {{ head.full_name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import 'select2';
import {setHeadSelected} from './store/flowState';

export default {
    name: 'HeadSelector',
    props: {
        organizationId: {
            type: [Number],
            required: true,
        },
    },
    data() {
        return {
            selectedOrg: this.organizationId,
            selectedHead: '',
            heads: [],
        };
    },
    methods: {
        async fetchHeads() {
            if (!this.selectedOrg) {
                this.heads = [];
                this.selectedHead = '';
                return;
            }

            try {
                const {data} = await axios.get(`/api/v1/organizations/${this.selectedOrg}/heads`);
                this.heads = data;
                this.selectedHead = '';

                this.$nextTick(() => {
                    $('#head_id').trigger('change.select2');
                });
            } catch (error) {
                console.error('Ошибка загрузки руководителей:', error);
                this.heads = [];
            }
        },
    },
    mounted() {
        const vm = this;

        this.fetchHeads();

        $('#head_id').select2().on('change', function () {
            vm.selectedHead = $(this).val();

            setHeadSelected(!!vm.selectedHead);
        });
    },
    beforeUnmount() {
        $('#head_id').off().select2('destroy');
    },
};
</script>
<style>
.select2-container--default.select2-container--disabled .select2-selection--single {
    background : white;
}
.select2-hidden-accessible {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
}

</style>
